import * as ActionTypes from '../../actions/allActions'

const accountProfileInit = {
	oldPassword: '',
	newPassword: '',
	newPasswordConfirmation: ''
}
const accountSecurity = (state = accountProfileInit, action) => {
	switch (action.type) {
		case ActionTypes.ACCOUNT_SECURITY_DATACHANGE:
			return { ...state, ...action.changes }
		default:
			return state
	}
}

export default accountSecurity


// WEBPACK FOOTER //
// ./src/reducers/data/accountSecurity.js